import React from "react";

import PlaceholderIMG from "../../sharedComponents/placeholderImage";

const BadgeCard = ({ cardDetails, onClick }) => {
    const { badge_count, description, image, name } = cardDetails;

    return <div className="card card-primary">
        <div className="p-3 text-center pointer" onClick={() => onClick(cardDetails)}>
            <PlaceholderIMG width="100" height="100" src={image} objectFit="contain" className="mt-2" />
            <h4 className="mt-3 mb-2">{name}</h4>
            <div className="text-truncate text-capitalize text-secondary mb-1">{description}</div>
            <div className="text-primary-dark">Total Badges: <span className="large">{badge_count}</span></div>
        </div>
    </div>
}

export default BadgeCard;
